import { render } from "./special2023.vue?vue&type=template&id=5e98f2ac&scoped=true"
import script from "./special2023.vue?vue&type=script&lang=js"
export * from "./special2023.vue?vue&type=script&lang=js"

import "./special2023.vue?vue&type=style&index=0&id=5e98f2ac&lang=less&scoped=true"

import exportComponent from "/home/jenkins_home/workspace/c1-02_dwart2.0-apkpc-site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e98f2ac"]])

export default __exports__